import { useEffect, useRef, useState } from 'react';
import type { UUID } from '@hoedokloop/domain';
import { useStudy } from '../features/study/study-context';
export function PhotoViewer({ assetId, alt }: { assetId: UUID; alt: string }) {
  const { getPhoto } = useStudy();
  const [thumb, setThumb] = useState<string>();
  const [full, setFull] = useState<string>();
  const [zoom, setZoom] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  const pane = useRef<HTMLDivElement>(null);
  const drag = useRef<{ x: number; y: number; left: number; top: number } | undefined>(undefined);
  useEffect(() => {
    let active = true;
    const urls: string[] = [];
    void getPhoto(assetId).then((photo) => {
      if (!active || !photo) return;
      urls.push(URL.createObjectURL(photo.thumbnail), URL.createObjectURL(photo.original));
      setThumb(urls[0]);
      setFull(urls[1]);
    });
    return () => {
      active = false;
      urls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [assetId, getPhoto]);
  return thumb ? (
    <>
      <button
        className="pn-photo-open"
        type="button"
        aria-label={`${alt} 크게 보기`}
        onClick={() => {
          setZoom(false);
          dialog.current?.showModal();
        }}
      >
        <img className="pn-note-photo" alt={alt} src={thumb} />
      </button>
      <dialog className="pn-photo-dialog" ref={dialog}>
        <div className="pn-inline-actions">
          <button className="pn-small-button" onClick={() => dialog.current?.close()}>
            닫기
          </button>
          <button className="pn-small-button" aria-pressed={zoom} onClick={() => setZoom(!zoom)}>
            {zoom ? '원래 크기' : '2배 확대'}
          </button>
        </div>
        <div
          className="pn-photo-pan"
          ref={pane}
          tabIndex={0}
          onPointerDown={(event) => {
            if (pane.current) {
              drag.current = {
                x: event.clientX,
                y: event.clientY,
                left: pane.current.scrollLeft,
                top: pane.current.scrollTop,
              };
              event.currentTarget.setPointerCapture(event.pointerId);
            }
          }}
          onPointerMove={(event) => {
            if (drag.current && pane.current) {
              pane.current.scrollLeft = drag.current.left + drag.current.x - event.clientX;
              pane.current.scrollTop = drag.current.top + drag.current.y - event.clientY;
            }
          }}
          onPointerUp={() => {
            drag.current = undefined;
          }}
          onPointerCancel={() => {
            drag.current = undefined;
          }}
        >
          <img src={full} alt={alt} style={{ width: zoom ? '200%' : '100%', maxWidth: 'none' }} />
        </div>
      </dialog>
    </>
  ) : null;
}
